import styledNormalize from 'styled-normalize';
import { createGlobalStyle } from 'styled-components';
import { isIFrame } from '~/utils';

export default createGlobalStyle`
  ${styledNormalize}

  * {
    box-sizing: border-box;
  }

  ${
    isIFrame()
      ? `
    body, html {
      overflow: hidden;
    }
  `
      : ''
  }

  html {
    width: 100%;
  }

  body {
    padding: 0;
    margin: 0;
    position: relative;
    width: 100%;
    line-height: 1.4;
    font-family: 'Source Sans Pro', sans-serif;
  }
`;
